/* eslint-disable no-debugger */
import React, { useEffect } from 'react';
import
{
    Box,
} from '@mui/material';
import { useState, Downgraded, createState } from '@hookstate/core';
import { generatePath } from 'react-router-dom';
import CircularProgress from '@mui/material/CircularProgress';
import RouteConstants from '../../../constants/routeConstants';
import SelectTransportation from './../selectTransportation';
import { useEventState, updateModuleState } from '../../../stores/eventStore';
import ApiHelper from '../../../utility/ApiHelper';
import Helper from '../../../utility/helper';

import APIURLConstants from '../../../config/config';
import { useAuthState } from '../../../stores/authStore';
import ConfirmationDialog from '../../../sharedcomponents/confirmationdialog/confirmationDialog';
import CustomizedSnackbars from '../../../sharedcomponents/snackbar/snackBar';
import DataList from '../../../sharedcomponents/accordianDataList/dataList';
import { NO_ACCESS_PERMISSION, FULL_PERMISSION } from '../../../constants/Constant';
import UnauthorizedUI from '../../../sharedcomponents/emptyStateContainer/unauthorizedUI';

const loader = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
    width: '100%',
};

const ticketState = createState({
    //totalTicket: 0,
    //usedTicket: 0,
    // remainingTicket: 0,
    //businessTicket: 0,
    //economyTicket: 0,
    noOfEconomyTicket: 0,
    noOBusinessTicket: 0,

    allocatedBusiness: 0,
    allocatedEconomy: 0,
    remainingArrivalBusiness: 0,
    remainingArrivalEconomy: 0,
    remainingDepartureBusiness: 0,
    remainingDepartureEconomy: 0,
    remainingGroundTransportTicket: 0
})

const DraftTransportation = (props) =>
{
     // const authState = useAuthState();
    const state = useState(ticketState);
    const transittype = useState(null);
    const openDialog = useState(false);
    const eventState = useEventState();
    const selectedEvent = useState(null);
    const transportList = useState(null);
    const authState = useAuthState();
    const loading = useState(false);
    const setAll = useState(false);
    const agentInfo = Helper.getStorage('agentUser') ? Helper.getStorage('agentUser') : Helper.getSessionStorage('agentUser');
    const userInfo = agentInfo ? agentInfo : Helper.getStorage('userInfo');
    const eventInfo = Helper.getStorage('eventInfo');
    const [arrivalUsedCount, setArrivalUsedCount] = React.useState(0);
    const [departureUsedCount, setDepartureUsedCount] = React.useState(0);
    const [transportTotalCount, setTransportTotalCount] = React.useState({
        arrival: 0,
        departure: 0
    });
    // const moduleIndex = useState(0)
    const [showSearchRec, setShowSearchRec] = React.useState(false);
    const [snackBarProps, setSnackBarProps] = React.useState({
        openSnack: false,
        variant: 'error',
        message: '',
    });
    const deleteConfirmation = useState({
        open: false,
        title: '',
        message: '',
    });

    const pagingInfo = useState({
        currentPage: 1,
        itemsPerPage: null,
        noOfPages: null,
    });
    const [modPermission, setModPermission] = React.useState(null);

    useEffect(() =>
    {
        const fetch = async () =>
        {
            const authStateInfo = authState
                .nested('appDetails')
                .attach(Downgraded)
                .get();
            if (
                authState &&
                authStateInfo &&
                authStateInfo.itemsPerPage &&
                pagingInfo.get().itemsPerPage == null &&
                modPermission && modPermission != NO_ACCESS_PERMISSION
            )
            {
                pagingInfo.set({
                    ...pagingInfo,
                    currentPage: 1,
                    itemsPerPage: authStateInfo.itemsPerPage,
                    noOfPages: null,
                });
                const eventDetail = selectedEvent.attach(Downgraded).get();
                await getEventDefaults();
                if (eventDetail && eventDetail.eventID)
                {
                    getTransportRequests();
                }
            }

        }
        fetch();
    }, [authState, modPermission, state.noOBusinessTicket.get(), state.noOfEconomyTicket.get()]);

    useEffect(() =>
    {
        if (selectedEvent.get() == null || selectedEvent.get())
        {
            if (eventState && eventState.eventDetail.get())
            {
                if (
                    selectedEvent.get() == null ||
                    eventState.eventDetail.get().eventID !=
                    selectedEvent.get().eventID
                )
                {
                    if (!Helper.isAdminUser(userInfo) || !Helper.isEventStaff(userInfo))
                    {
                        const permissions = eventState.permissions.attach(Downgraded).get();
                        if (permissions && permissions.length > 0)
                        {
                            setModPermission(Helper.getModuleAccessPermission(permissions, 'DRAFTTRANSPORTATION'));
                        }
                    }
                    else if (Helper.isAdminUser(userInfo) || Helper.isEventStaff(userInfo))
                    {
                        setModPermission(FULL_PERMISSION)
                    }
                    selectedEvent.set(
                        eventState.eventDetail.attach(Downgraded).get()
                    );
                }
            }
            // else {
            //     const eventInfo = Helper.getStorage('eventInfo');
            //     if (
            //         selectedEvent.get() == null ||
            //         selectedEvent.get().eventID != selectedEvent.get().eventID
            //     ) {
            //         selectedEvent.set(eventInfo);
            //     }
            // }
        }
    }, [eventState]); 
    // const getModuleDetailsData = () => {
    //     const index = eventState.eventDetail.get().moduleDetails.findIndex((element) => {
    //         if (element.moduleName === 'Transportation') {
    //           return true
    //         }
    //       })
    //       moduleIndex.set(index)
    // }

    const getEventDefaults = () =>
    { 
        loading.set(true)
        return ApiHelper.get(APIURLConstants.GET_DRAFT_TRANSPORT_SETTING_BY_USER_ID(eventInfo.eventID, userInfo.userID)).then(res =>
        {
            if (res.data)
            {
                loading.set(false)
                res.data.map((count) =>
                {
                     if (count.setting)
                    {
                        const transportSettingData = JSON.parse(count.setting)
                        // console.log("transportSettingData",transportSettingData);
                        if (transportSettingData && transportSettingData !== undefined)
                        {
                            if(transportSettingData[0].TransportSetting !== null){
                                const finalSettingData = JSON.parse(transportSettingData[0].TransportSetting)   
                                // console.log(finalSettingData);                         
                                state.set({
                                    ...state.get(),
                                    noOBusinessTicket: finalSettingData?.draftTransportCount ?? 0 
                                })
                            } else{
                                state.set({
                                    ...state.get(),
                                    noOBusinessTicket: 0
                                }) 
                            }
                        }
                    }
                })
            }
            
        })
    }
// console.log("noOBusinessTicket",state.get().noOBusinessTicket);
    const handleClick = () =>
    {
        handleAction('Air')
        // openDialog.set(true);
    };

    const handleClose = () =>
    {
        openDialog.set(false);
    };

    const handleAction = (value) =>
    {
        transittype.set(value);
        console.log(state.get());
        // return false
        if(Number(state.attach(Downgraded).get().noOBusinessTicket) > 0){
            props.history.push({
                pathname: generatePath(RouteConstants.DRAFT_EVENT_CREATE_TRANSIT, { eventID: eventInfo.eventID }),
                state: {
                    transitType: value,
                    originalBusinessTickets: Number(state.attach(Downgraded).get().noOBusinessTicket),
                    // originalEconomyTickets: state.attach(Downgraded).get().noOfEconomyTicket,
                    allocatedBusiness: state.attach(Downgraded).get().allocatedBusiness,
                    // allocatedEconomy: state.attach(Downgraded).get().allocatedEconomy,
                    remainingArrivalBusiness: state.attach(Downgraded).get().remainingArrivalBusiness,
                    // remainingArrivalEconomy: state.attach(Downgraded).get().remainingArrivalEconomy,
                    remainingDepartureBusiness: state.attach(Downgraded).get().remainingDepartureBusiness,
                    // remainingDepartureEconomy: state.attach(Downgraded).get().remainingDepartureEconomy,
                    remainingGroundTransportTicket:  state.attach(Downgraded).get().remainingGroundTransportTicket
                }
            });
            openDialog.set(false);
        }else{
            setSnackBarProps({
                ...snackBarProps,
                openSnack: true,
                variant: 'error',
                message: 'Please Configure Allotment first',
            });
        }
        
    };

    const redirectToTransit = (row) =>
    {
        const path = generatePath(RouteConstants.DRAFT_EVENT_EDIT_TRANSIT, {
            eventID: row.actualData.eventID,
            transitID: row.actualData.draftTransportID,
        });

        let newRemainingArrivalBusiness = state.attach(Downgraded).get().remainingArrivalBusiness
        // let newRemainingArrivalEconomy = state.attach(Downgraded).get().remainingArrivalEconomy
        let newRemainingDepartureBusiness = state.attach(Downgraded).get().remainingDepartureBusiness
        // let newRemainingDepartureEconomy = state.attach(Downgraded).get().remainingDepartureEconomy

        if (row.actualData.tripInfoType === 'departure')
        {
            if (row.actualData.ticketType === 1)
            {
                newRemainingDepartureBusiness += 1;
            } 
            // else
            // {
            //     newRemainingDepartureEconomy += 1;
            // }
        } else if (row.actualData.tripInfoType === 'arrival')
        {
            if (row.actualData.ticketType === 1)
            {
                newRemainingArrivalBusiness += 1;
            } 
            // else
            // {
            //     newRemainingArrivalEconomy += 1;
            // }
        }
        props.history.push({
            pathname: path,
            state: {
                transitType: row.actualData.transitType,
                originalBusinessTickets: Number(state.attach(Downgraded).get().noOBusinessTicket),
                // originalEconomyTickets: state.attach(Downgraded).get().noOfEconomyTicket,
                allocatedBusiness: state.attach(Downgraded).get().allocatedBusiness,
                // allocatedEconomy: state.attach(Downgraded).get().allocatedEconomy,
                remainingArrivalBusiness: newRemainingArrivalBusiness,
                // remainingArrivalEconomy: newRemainingArrivalEconomy,
                remainingDepartureBusiness: newRemainingDepartureBusiness,
                // remainingDepartureEconomy: newRemainingDepartureEconomy,
                remainingGroundTransportTicket:  state.attach(Downgraded).get().remainingGroundTransportTicket
            },
        });
    };

    const calculateRemainingTickets = (data) =>
    {
        //  console.log("data",data);
         
        //let data = transportList.attach(Downgraded).get().map(x => x.actualData)
        const stateStore = state.attach(Downgraded).get()
        let totalAllocatedBusinessTickets = Number(stateStore.noOBusinessTicket)
        // let totalAllocatedEconomyTickets = Number(stateStore.noOfEconomyTicket)

        let totalAllocatedArrivalBusinessTickets = totalAllocatedBusinessTickets
        let totalAllocatedDepartureBusinessTickets = totalAllocatedBusinessTickets

        // let totalAllocatedArrivalEconomyTickets = totalAllocatedEconomyTickets
        // let totalAllocatedDepartureEconomyTickets = totalAllocatedEconomyTickets

        const departureBusinessCount = data.rows.filter(item =>
            // item.ticketType == 1 &&
            !item.isGroundTransport &&
            item.transitType.toLowerCase() == 'air' &&
            item.tripInfoType == 'departure'
        ).length;
        // const departureEconomyCount = data.rows.filter(item =>
        //     item.ticketType == 2 &&
        //     item.transitType.toLowerCase() == 'air' &&
        //     item.tripInfoType == 'departure'
        // ).length;

        const arrivalBusinessCount = data.rows.filter(item =>
            // item.ticketType == 1 &&
            !item.isGroundTransport &&
            item.transitType.toLowerCase() == 'air' &&
            item.tripInfoType == 'arrival'
        ).length;
        // const arrivalEconomyCount = data.rows.filter(item =>
        //     item.ticketType == 2 &&
        //     item.transitType.toLowerCase() == 'air' &&
        //     item.tripInfoType == 'arrival'
        // ).length;
        // console.log(data.rows,"arrivalBusinessCount",arrivalBusinessCount,"arrivalEconomyCount",arrivalEconomyCount);
        const GroundTransportCount = data.rows.filter(item =>
            // item.ticketType == 1 &&
            item.isGroundTransport &&
            item.transitType.toLowerCase() == 'air' &&
            item.tripInfoType == "arrival"
        ).length;
        let finalTotalBusinessTickets = Number(totalAllocatedBusinessTickets)
        // let finalTotalEconomyTickets = Number(totalAllocatedEconomyTickets)

        let finalAllocatedArrivalBusinessTickets = Number(totalAllocatedArrivalBusinessTickets)
        // let finalAllocatedArrivalEconomyTickets = Number(totalAllocatedArrivalEconomyTickets)
        let finalAllocatedDepartureBusinessTickets = Number(totalAllocatedDepartureBusinessTickets)
        // let finalAllocatedDepartureEconomyTickets = Number(totalAllocatedDepartureEconomyTickets)

        let remainingArrivalBusinessTickets = 0
        let remainingDepartureBusinessTickets = 0
        let remainingGroundTransportTicket = 0
        // let remainingArrivalEconomyTickets = 0
        // let remainingDepartureEconomyTickets = 0

        // if (arrivalEconomyCount > totalAllocatedArrivalEconomyTickets || departureEconomyCount > totalAllocatedDepartureEconomyTickets)
        // {
        //     let maxCount = Math.max(arrivalEconomyCount, departureEconomyCount);
        //     if (maxCount === arrivalEconomyCount)
        //     {
        //         let extraCount = maxCount - totalAllocatedEconomyTickets

        //         //check if extra economy is in multiple of 2 (even)
        //         let numerator = Math.floor(extraCount / 2);
        //         if (numerator > 0)
        //         {
        //             finalAllocatedArrivalBusinessTickets = finalAllocatedArrivalBusinessTickets - numerator
        //             finalAllocatedDepartureBusinessTickets = finalAllocatedDepartureBusinessTickets - numerator

        //             finalAllocatedArrivalEconomyTickets = finalAllocatedArrivalEconomyTickets + (numerator * 2)
        //             finalAllocatedDepartureEconomyTickets = finalAllocatedDepartureEconomyTickets + (numerator * 2)
        //         }

        //         //check if extra economy is not multiple of 2(odd)
        //         let denominator = extraCount % 2;

        //         if (Number(denominator) > 0)
        //         {
        //             finalAllocatedArrivalBusinessTickets = Number(finalAllocatedArrivalBusinessTickets) - Number(denominator)
        //             finalAllocatedDepartureBusinessTickets = Number(finalAllocatedDepartureBusinessTickets) - Number(denominator)

        //             finalAllocatedArrivalEconomyTickets = Number(finalAllocatedArrivalEconomyTickets) + Number(denominator * 2)
        //             finalAllocatedDepartureEconomyTickets = Number(finalAllocatedDepartureEconomyTickets) + Number(denominator * 2)
        //         }
        //     }

        // }
        finalTotalBusinessTickets = finalAllocatedArrivalBusinessTickets
        // finalTotalEconomyTickets = finalAllocatedArrivalEconomyTickets
        // console.log("arrivalBusinessCount",arrivalBusinessCount,departureBusinessCount,GroundTransportCount);

        remainingArrivalBusinessTickets = finalAllocatedArrivalBusinessTickets - arrivalBusinessCount
        remainingDepartureBusinessTickets = finalAllocatedDepartureBusinessTickets - departureBusinessCount
        remainingGroundTransportTicket = finalTotalBusinessTickets - GroundTransportCount
        // remainingArrivalEconomyTickets = finalAllocatedArrivalEconomyTickets - arrivalEconomyCount
        // remainingDepartureEconomyTickets =  finalAllocatedDepartureEconomyTickets - departureEconomyCount

        // console.log('Total Business',finalTotalBusinessTickets)
        // console.log('Total Economy',finalTotalEconomyTickets)
        // console.log('Remaining')
        // console.log('Arrival Business',remainingArrivalBusinessTickets)
        // console.log('Arrival Economy',remainingArrivalEconomyTickets)

        // console.log('Departure Business',remainingDepartureBusinessTickets)
        // console.log('Departure Economy' + remainingDepartureEconomyTickets)

        state.set({
            ...state.get()
            , allocatedBusiness: finalTotalBusinessTickets
            // , allocatedEconomy: finalTotalEconomyTickets
            , remainingArrivalBusiness: remainingArrivalBusinessTickets
            // , remainingArrivalEconomy: remainingArrivalEconomyTickets
            , remainingDepartureBusiness: remainingDepartureBusinessTickets
            , remainingGroundTransportTicket : remainingGroundTransportTicket
            // , remainingDepartureEconomy: remainingDepartureEconomyTickets
        })
    }
    // const getTotalFlightCount = (userID) =>
    // {
    //     const eventInfo = Helper.getStorage('eventInfo');
    //     const gAgentInfo=Helper.getStorage('agentUser');
    //     const agentConnection = Helper.getStorage('agentConnections');
    //     loading.set(true);
    //     ApiHelper.get(APIURLConstants.GET_TRANSPORT_SETTING_BY_USER_ID(eventInfo.eventID,agentConnection && gAgentInfo? gAgentInfo.userID: userID))
    //         .then((res) =>
    //         {
    //             if (res.data)
    //             { 
    //                 loading.set(false);
    //                 res.data.map((count) =>
    //                 {
    //                     if(count.setting){
    //                         // console.log("123");
    //                         // const transportSettingData = JSON.parse(count.setting)
    //                         // if(transportSettingData){ 
    //                         //     const finalSettingData = JSON.parse(transportSettingData[0].TransportSetting)
    //                         //         setTransportTotalCount({
    //                         //         arrival: finalSettingData.arrival,
    //                         //         departure: finalSettingData.departure
    //                         //     }) 
    //                         // }
    //                     } 
    //                 }) 
    //             }
    //         })
    // }
    const getTransportRequests = () =>
    {
        // const eventDetail = selectedEvent.attach(Downgraded).get();
        // const userInfo = Helper.getStorage('userInfo');
        // const gAgentInfo = Helper.getSessionStorage('agentUser');
        // const agentConnection = Helper.getSessionStorage('agentConnections');
        loading.set(true);
        ApiHelper.get(
            APIURLConstants.GET_DRAFT_TRANSPORT_LIST(
                eventInfo.eventID,
                userInfo.userID,
                pagingInfo.get().currentPage,
                pagingInfo.get().itemsPerPage
            )
        )
            .then((res) =>
            {
                if (res.data.rows)
                {
                    let data = res.data.rows;
                    // const businessCount = res.data.rows.filter(item =>
                    //     item.ticketType == 1 &&
                    //     item.transitType.toLowerCase() == 'air'
                    // );
                    // const economyCount = res.data.rows.filter(item =>
                    //     item.ticketType == 2 &&
                    //     item.transitType.toLowerCase() == 'air'
                    // );

                    calculateRemainingTickets(res.data);
                    // console.log('businessCount', businessCount.length)
                    // console.log('economyCount', economyCount.length)

                    // state.set({
                    //     ...state.get(), businessTicket: businessCount.length, economyTicket: economyCount.length,
                    //     usedTicket: businessCount.length + economyCount.length,
                    //     remainingTicket: (state.attach(Downgraded).get().totalTicket - (businessCount.length + economyCount.length))

                    // })

                    let transList = [];
                    if (data.length > 0)
                    {
                        data.map((item) =>
                        {
                            item.usedCounts.map((count) =>
                            {
                                if (count.tripInfoType === "arrival")
                                {
                                    setArrivalUsedCount(count.usedCount);
                                } else if (count.tripInfoType === "departure")
                                {
                                    setDepartureUsedCount(count.usedCount);
                                }
                            }) 
                            if(item.transportAllStarSetting && item.transportAllStarSetting !== undefined && item.transportAllStarSetting.length > 0 && item.transportAllStarSetting[0].setting)  {
                                const settingParse = JSON.parse(item.transportAllStarSetting[0].setting);
                                const totalParse = settingParse && JSON.parse(settingParse[0].TransportSetting)
                                if(totalParse){
                                    setTransportTotalCount({
                                        arrival:totalParse.arrival,
                                        departure:totalParse.departure
                                    })
                                }
                            }
                            if(item.isGroundTransport){
                                transList.push({
                                    actualData: item,
                                    row: [
                                        {
                                            label: 'checkbox',
                                            key: 'transportID',
                                            transportID: item.transportID,
                                            width: '0.05',
                                        },
                                        {
                                            label: 'Transport Type',
                                            key: 'transitType',
                                            transitType: `${item.transitType} - ${item.transitType?.toLowerCase() === 'air' ? 'Event' : ''} ${item.tripInfoType}`,
                                            width: '0.2',
                                            inColumn: true,
                                        },  
                                        {
                                            label: 'Ground Transport Needed',
                                            key: 'groundTransportNeeded',
                                            groundTransportNeeded: item.isGroundTransport ? "Yes" : "No",
                                            width: '0.25',
                                            inColumn: true,
                                        },                                  
                                        {
                                            label: 'Pickup Address',
                                            key: 'groundPickupAddress',
                                            groundPickupAddress: item.groundPickupAddress,
                                            width: '0.15',
                                            inColumn: true,
                                        },
                                        {
                                            label: 'Drop-off Address',
                                            key: 'groundDropoffAddress',
                                            groundDropoffAddress: item.groundDropoffAddress,
                                            width: '0.15',
                                            inColumn: true,
                                        },                                  
                                        {
                                            label: 'Status',
                                            key: 'requestStatus',
                                            requestStatus: item.requestStatus,
                                            width: '0.1',
                                            showStatusIcon: true,
                                            inColumn: true,
                                            alignCenter: true,
                                        },
                                        {
                                            label: 'Action',
                                            key: 'editnote',
                                            editnote: item.requestStatus.toLowerCase() == 'pending'? '': item.note,
                                            width: '0.1',
                                        },
                                    ],
                                    selected: false,
                                });
                            }else{
                                transList.push({
                                actualData: item,
                                row: [
                                    {
                                        label: 'checkbox',
                                        key: 'transportID',
                                        transportID: item.transportID,
                                        width: '0.05',
                                    },
                                    {
                                        label: 'Transport Type',
                                        key: 'transitType',
                                        transitType: `${item.transitType} - ${item.transitType?.toLowerCase() === 'air' ? 'Event' : ''} ${item.tripInfoType}`,
                                        width: '0.2',
                                        inColumn: true,
                                    },                                    
                                    {
                                        label: 'From',
                                        key: 'fromLocation',
                                        fromLocation: item.fromLocation,
                                        width: '0.25',
                                        inColumn: true,
                                    },
                                    {
                                        label: 'To',
                                        key: 'toLocation',
                                        toLocation: item.toLocation,
                                        width: '0.15',
                                        inColumn: true,
                                    },
                                    {
                                        label: 'Date',
                                        key: 'fromDate',
                                        fromDate: item.fromDate === "0001-01-01T00:00:00" ? Helper.FormatDateTime(item.toDate) : Helper.FormatDateTime(item.fromDate),
                                        width: '0.15',
                                        inColumn: true,
                                    },                                   
                                    {
                                        label: 'Status',
                                        key: 'requestStatus',
                                        requestStatus: item.requestStatus,
                                        width: '0.1',
                                        showStatusIcon: true,
                                        inColumn: true,
                                        alignCenter: true,
                                    },
                                    {
                                        label: 'Action',
                                        key: 'editnote',
                                        editnote: item.requestStatus.toLowerCase() == 'pending'? '': item.note,
                                        width: '0.1',
                                    },
                                ],
                                selected: false,
                            });
                            }
                            
                        });
                    }else{
                        // getTotalFlightCount(userInfo.userID)
                    }

                    // data.map(item => item.selected = false);
                    transportList.set(transList);
                    loading.set(false);
                    if (pagingInfo.get().noOfPages == null)
                    {
                        pagingInfo.set({
                            ...pagingInfo,
                            currentPage: pagingInfo.get().currentPage,
                            itemsPerPage: pagingInfo.get().itemsPerPage,
                            noOfPages: Math.ceil(
                                res.data.totalCount /
                                pagingInfo.get().itemsPerPage
                            ),
                        });
                    }
                }
            })
            .catch((error) =>
            {
                console.log('error : ', error);
            });
    };

    const handlePageChange = (event, page) =>
    {
        pagingInfo.set({
            ...pagingInfo,
            currentPage: page,
            itemsPerPage: pagingInfo.get().itemsPerPage,
            noOfPages: pagingInfo.get().noOfPages,
        });
        getTransportRequests();
    };

    const deleteRows = () =>
    {
        const selected = transportList.get().filter((row) => row.selected === true);
        if (selected.length === 0)
        {
            setSnackBarProps({
                ...snackBarProps,
                openSnack: true,
                variant: 'error',
                message: 'Please select request first',
            });
        } else
        {
            let message = setAll.get()
                ? 'Do you want to delete all request?'
                : 'Do you want to delete selected request?';

            deleteConfirmation.set({
                open: true,
                title: '',
                OkButtonText: 'Ok',
                message: message,
            });
        }
    }
    const handleConfirmation = () =>
    {
        let deleteRequests = [];
        transportList.get().map((row) =>
        { 
            if (row.selected === true)
            {
                deleteRequests.push(row.actualData.draftTransportID);
            }
        });

        const userInfo = Helper.getStorage('userInfo');
        ApiHelper.post(APIURLConstants.DELETE_DRAFT_TRANSPORT, {
            Ids: deleteRequests.join(','),
            Delete: true,
            ModifiedBy: userInfo.userID,
        })
            .then((res) =>
            {
                if (res.data)
                {
                    setSnackBarProps({
                        ...snackBarProps,
                        openSnack: true,
                        variant: 'success',
                        message: 'Request deleted successfully',
                    });
                    updateModuleState();
                    getTransportRequests();
                }
            })
            .catch((error) =>
            {
                let message = '';
                if (error.response && error.response.status === 401)
                {
                    message = 'Access denied';
                } else
                {
                    message = 'Error while deleting request';
                }
                setSnackBarProps({
                    ...snackBarProps,
                    openSnack: true,
                    variant: 'error',
                    message: message,
                });
            });
        deleteConfirmation.set({
            open: false,
            title: '',
            OkButtonText: 'Ok',
            message: '',
        });
    };
    // console.log("transportTotalCount",modPermission);
    return (
        <Box sx={{ width: '100%' }}>

            <Box
                className="otherContentBox"
                sx={{
                    // p: 2,
                    '& .MuiGrid-item': { p: 2 },
                    '& .MuiFormControl-root': { width: '100%' },
                }}>


                {loading.get() ? (
                    <Box style={loader}>
                        <CircularProgress />
                    </Box>
                ) :
                    modPermission && modPermission == NO_ACCESS_PERMISSION ?
                        <UnauthorizedUI showLogout={false} />
                        :
                        transportList.get() ? (
                            <DataList
                                data={transportList.attach(Downgraded).get()}
                                editRow={redirectToTransit}
                                handleClick={handleClick}
                                title={''}
                                buttonTitle={'Add'}
                                deleteRows={deleteRows}
                                hideDelete={eventInfo.readonlyOrHide === 0 ? false : true}
                                showSearch={true}
                                //totalBusiness={state.attach(Downgraded).get().noOBusinessTicket}
                                //totalEconomy={state.attach(Downgraded).get().noOfEconomyTicket}
                                totalTickets={state.attach(Downgraded).get().allocatedBusiness + ' | '+  state.attach(Downgraded).get().allocatedEconomy}
                                showTiketCount={false}
                                arrivalUsedCount={arrivalUsedCount}
                                departureUsedCount={departureUsedCount}
                                transportTotalCount={transportTotalCount}
                                usedTickets={state.attach(Downgraded).get().usedTicket}
                                remainingTickets={state.attach(Downgraded).get().remainingTicket}
                                allocatedBusiness={state.attach(Downgraded).get().noOBusinessTicket}
                                allocatedEconomy={state.attach(Downgraded).get().noOfEconomyTicket}
                                remainingArrivalBusiness={state.attach(Downgraded).get().remainingArrivalBusiness}
                                remainingArrivalEconomy={state.attach(Downgraded).get().remainingArrivalEconomy}
                                remainingDepartureBusiness={state.attach(Downgraded).get().remainingDepartureBusiness}
                                remainingDepartureEconomy={state.attach(Downgraded).get().remainingDepartureEconomy}
                                searchLabel={'Search'}
                                showSearchRec={showSearchRec}
                                setShowSearchRec={setShowSearchRec}
                                pagingInfo={pagingInfo.attach(Downgraded).get()}
                                handlePageChange={handlePageChange}
                                moduleToShow={"Draft Transportation"}
                                modPermission={modPermission}
                                titleHeader='DraftTransportation'
                                enduser={true}
                                showExpandCollapseValue={false}
                                disableAdd={eventInfo.readonlyOrHide === 0 ? false : true}
                            />
                        ) : null}

                {openDialog.get() && (
                    <SelectTransportation
                        open={openDialog.get()}
                        title="Select Transportation Type"
                        handleClose={handleClose}
                        handleAction={handleAction}
                    />
                )}
                {snackBarProps.openSnack && (
                    <CustomizedSnackbars
                        {...snackBarProps}
                        onClose={() =>
                            setSnackBarProps({
                                ...snackBarProps,
                                openSnack: false,
                            })
                        }></CustomizedSnackbars>
                )}
                {
                    <ConfirmationDialog
                        open={deleteConfirmation.get().open}
                        message={deleteConfirmation.get().message}
                        OkButtonText={deleteConfirmation.get().OkButtonText}
                        handleCnfClick={() =>
                            handleConfirmation(deleteConfirmation)
                        }
                        onCancelClick={() =>
                        {
                            deleteConfirmation.set({
                                ...deleteConfirmation.get(),
                                open: false,
                            });
                        }}></ConfirmationDialog>
                }
            </Box>
        </Box>
    );
};

export default {
    routeProps: {
        path: RouteConstants.DRAFT_EVENT_TRANSIT,
        component: DraftTransportation,
    },
    name: 'DraftTransportation',
};
